import * as React from 'react';
import { IGatsbyImageData, GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { classnames } from 'helpers/utils';
import * as styles from './related-card.module.scss';

interface RelatedCardProps {
  image: IGatsbyImageData | undefined
  title: string
  slug: string
  description?: string
  className?: string
}

export const RelatedCard: React.FC<RelatedCardProps> = ({
  image, title, slug, description, className,
}) => (
  <Link to={slug} className={classnames(styles.card, className || '')}>
    {image
      && (
        <GatsbyImage
          image={image}
          alt={title}
          className={styles.cardImage}
        />
      )}
    <div className={styles.cardContent}>
      <span className={styles.cardTitle}>{title}</span>
      {description && (<p className={styles.cardDescription}>{description}</p>)}
    </div>
  </Link>
);
